export const PARTNER_LIST = 'PARTNER_LIST'
export const SELECT = 'SELECT'
export const OWNED_GET = 'OWNED_GET'
export const CLEAR_ALL = 'CLEAR_ALL'
export const CLEAR_SELECTED = 'CLEAR_SELECTED'
